export default {
  getTenantWaitingList(params) {
    return this.get(`/pms_api/v3/owner/waiting-list`, { params });
  },
};
